import { CustomFieldModel } from '../../../api/models';

export const HHA_CUSTOM_PATIENT_FIELDS: Partial<CustomFieldModel>[] = [
  // {
  //   fieldTitle: 'Agency Id',
  //   fieldKey: 'AgencyID',
  //   fieldType: 'number',
  // },
  {
    fieldTitle: 'Office Id',
    fieldKey: 'OfficeID',
    fieldType: 'number',
  },
  {
    fieldTitle: 'Patient Id',
    fieldKey: 'PatientID',
    fieldType: 'number',
  },
  {
    fieldTitle: 'Birth Date',
    fieldKey: 'BirthDate',
    fieldType: 'date',
  },
  {
    fieldTitle: 'Gender',
    fieldKey: 'Gender',
    fieldType: 'text',
  },
  {
    fieldTitle: 'Coordinators Names',
    fieldKey: 'Coordinators.Coordinator.Name',
    fieldType: 'list',
  },
  {
    fieldTitle: 'Coordinators Ids',
    fieldKey: 'Coordinators.Coordinator.ID',
    fieldType: 'list',
  },
  {
    fieldTitle: 'Priority Code',
    fieldKey: 'PriorityCode',
    fieldType: 'number',
  },
  {
    fieldTitle: 'Service Request Start Date',
    fieldKey: 'ServiceRequestStartDate',
    fieldType: 'date',
  },
  {
    fieldTitle: 'Nurse',
    fieldKey: 'Nurse.Name',
    fieldType: 'text',
  },
  {
    fieldTitle: 'Nurse Id',
    fieldKey: 'Nurse.ID',
    fieldType: 'number',
  },
  {
    fieldTitle: 'Admission Id',
    fieldKey: 'AdmissionID',
    fieldType: 'number',
  },
  {
    fieldTitle: 'Medicaid Number',
    fieldKey: 'MedicaidNumber',
    fieldType: 'text',
  },
  {
    fieldTitle: 'Medicare Number',
    fieldKey: 'MedicareNumber',
    fieldType: 'text',
  },
  {
    fieldTitle: 'Accepted Services',
    fieldKey: 'AcceptedServices.Discipline',
    fieldType: 'list',
  },
  {
    fieldTitle: 'SSN',
    fieldKey: 'SSN',
    fieldType: 'text',
  },
  {
    fieldTitle: 'Alerts',
    fieldKey: 'Alerts',
    fieldType: 'text',
  },
  {
    fieldTitle: 'Source Of Admission Id',
    fieldKey: 'SourceOfAdmission.ID',
    fieldType: 'number',
  },
  {
    fieldTitle: 'Source Of Admission Name',
    fieldKey: 'SourceOfAdmission.Name',
    fieldType: 'text',
  },
  {
    fieldTitle: 'Team Id',
    fieldKey: 'Team.ID',
    fieldType: 'number',
  },
  {
    fieldTitle: 'Team Name',
    fieldKey: 'Team.Name',
    fieldType: 'text',
  },
  {
    fieldTitle: 'Location Id',
    fieldKey: 'Location.ID',
    fieldType: 'number',
  },
  {
    fieldTitle: 'Location Name',
    fieldKey: 'Location.Name',
    fieldType: 'text',
  },
  {
    fieldTitle: 'Branch Id',
    fieldKey: 'Branch.ID',
    fieldType: 'number',
  },
  {
    fieldTitle: 'Branch Name',
    fieldKey: 'Branch.Name',
    fieldType: 'text',
  },

  {
    fieldTitle: 'Addresses Ids',
    fieldKey: 'Addresses.Address.AddressID',
    fieldType: 'list',
  },
  {
    fieldTitle: 'Addresses 1',
    fieldKey: 'Addresses.Address.Address1',
    fieldType: 'list',
  },
  {
    fieldTitle: 'Addresses 2',
    fieldKey: 'Addresses.Address.Address2',
    fieldType: 'list',
  },
  {
    fieldTitle: 'Addresses Cross Streets',
    fieldKey: 'Addresses.Address.CrossStreets',
    fieldType: 'list',
  },
  {
    fieldTitle: 'Addresses Cities',
    fieldKey: 'Addresses.Address.Cities',
    fieldType: 'list',
  },
  {
    fieldTitle: 'Addresses Zip5',
    fieldKey: 'Addresses.Address.Zip5',
    fieldType: 'list',
  },
  {
    fieldTitle: 'Addresses Zip3',
    fieldKey: 'Addresses.Address.Zip4',
    fieldType: 'list',
  },
  {
    fieldTitle: 'Addresses States',
    fieldKey: 'Addresses.Address.State',
    fieldType: 'list',
  },
  {
    fieldTitle: 'Addresses Countries',
    fieldKey: 'Addresses.Address.County',
    fieldType: 'list',
  },
  {
    fieldTitle: 'Addresses Types',
    fieldKey: 'Addresses.Address.AddressTypes',
    fieldType: 'list',
  },
  // {
  //   fieldTitle: 'Addresses IsPrimary',
  //   fieldKey: 'Addresses.Address.IsPrimaryAddress',
  //   fieldType: 'list',
  // },
  // {
  //   fieldTitle: 'Home Phone',
  //   fieldKey: 'HomePhone',
  //   fieldType: 'text',
  // },
  // {
  //   fieldTitle: 'Phone 2',
  //   fieldKey: 'Phone2',
  //   fieldType: 'text',
  // },
  {
    fieldTitle: 'Phone 2 Description',
    fieldKey: 'Phone2Description',
    fieldType: 'text',
  },
  // {
  //   fieldTitle: 'Phone 3',
  //   fieldKey: 'Phone3',
  //   fieldType: 'text',
  // },
  {
    fieldTitle: 'Phone 3 Description',
    fieldKey: 'Phone3Description',
    fieldType: 'text',
  },
  {
    fieldTitle: 'Home Phone Location Address Id',
    fieldKey: 'HomePhoneLocationAddressID',
    fieldType: 'text',
  },
  {
    fieldTitle: 'Home Phone Location Address',
    fieldKey: 'HomePhoneLocationAddress',
    fieldType: 'text',
  },
  {
    fieldTitle: 'Home Phone 2 Location Address Id',
    fieldKey: 'HomePhone2LocationAddressID',
    fieldType: 'text',
  },
  {
    fieldTitle: 'Home Phone 2 Location Address',
    fieldKey: 'HomePhone2LocationAddress',
    fieldType: 'text',
  },
  {
    fieldTitle: 'Home Phone 3 Location Address Id',
    fieldKey: 'HomePhone3LocationAddressID',
    fieldType: 'text',
  },
  {
    fieldTitle: 'Home Phone 3 Location Address',
    fieldKey: 'HomePhone3LocationAddress',
    fieldType: 'text',
  },
  {
    fieldTitle: 'Direction',
    fieldKey: 'Direction',
    fieldType: 'text',
  },
  {
    fieldTitle: 'Alternate Billing First Name',
    fieldKey: 'AlternateBilling.FirstName',
    fieldType: 'text',
  },
  {
    fieldTitle: 'Alternate Billing Middle Name',
    fieldKey: 'AlternateBilling.MiddleName',
    fieldType: 'text',
  },
  {
    fieldTitle: 'Alternate Billing Last Name',
    fieldKey: 'AlternateBilling.LastName',
    fieldType: 'text',
  },
  {
    fieldTitle: 'Alternate Billing Street',
    fieldKey: 'AlternateBilling.Street',
    fieldType: 'text',
  },
  {
    fieldTitle: 'Alternate Billing City',
    fieldKey: 'AlternateBilling.City',
    fieldType: 'text',
  },
  {
    fieldTitle: 'Alternate Billing State',
    fieldKey: 'AlternateBilling.State',
    fieldType: 'text',
  },
  {
    fieldTitle: 'Alternate Billing Zip5',
    fieldKey: 'AlternateBilling.Zip5',
    fieldType: 'text',
  },

  {
    fieldTitle: 'Emergency Contacts Names',
    fieldKey: 'EmergencyContacts.EmergencyContact.Name',
    fieldType: 'list',
  },
  {
    fieldTitle: 'Emergency Contacts Relationships Ids',
    fieldKey: 'EmergencyContacts.EmergencyContact.Relationship.ID',
    fieldType: 'list',
  },
  {
    fieldTitle: 'Emergency Contacts Relationships Names',
    fieldKey: 'EmergencyContacts.EmergencyContact.Relationship.Name',
    fieldType: 'list',
  },
  {
    fieldTitle: 'Emergency Contacts Lives With Patient',
    fieldKey: 'EmergencyContacts.EmergencyContact.LivesWithPatient',
    fieldType: 'list',
  },
  {
    fieldTitle: 'Emergency Contacts Have Keys',
    fieldKey: 'EmergencyContacts.EmergencyContact.HaveKeys',
    fieldType: 'list',
  },
  {
    fieldTitle: 'Emergency Contacts Phone 1',
    fieldKey: 'EmergencyContacts.EmergencyContact.Phone1',
    fieldType: 'list',
    fieldFormat: 'phoneNumber',
  },
  {
    fieldTitle: 'Emergency Contacts Phone 2',
    fieldKey: 'EmergencyContacts.EmergencyContact.Phone2',
    fieldType: 'list',
    fieldFormat: 'phoneNumber',
  },
  {
    fieldTitle: 'Emergency Contacts Address',
    fieldKey: 'EmergencyContacts.EmergencyContact.Address',
    fieldType: 'text',
  },
  {
    fieldTitle: 'Evacuation Zone Id',
    fieldKey: 'EmergencyPreparedness.EvacuationZone.ID',
    fieldType: 'number',
  },
  {
    fieldTitle: 'Evacuation Zone Name',
    fieldKey: 'EmergencyPreparedness.EvacuationZone.Name',
    fieldType: 'text',
  },
  {
    fieldTitle: 'Evacuation Location Id',
    fieldKey: 'EmergencyPreparedness.EvacuationLocation.ID',
    fieldType: 'number',
  },
  {
    fieldTitle: 'Evacuation Location Name',
    fieldKey: 'EmergencyPreparedness.EvacuationLocation.Name',
    fieldType: 'text',
  },
  {
    fieldTitle: 'Mobility Status Id',
    fieldKey: 'EmergencyPreparedness.MobilityStatus.ID',
    fieldType: 'number',
  },
  {
    fieldTitle: 'Mobility Status Name',
    fieldKey: 'EmergencyPreparedness.MobilityStatus.Name',
    fieldType: 'text',
  },
  {
    fieldTitle: 'Electric Equipment Dependency',
    fieldKey: 'EmergencyPreparedness.ElectricEquipmentDependency.ElectricEquipmentID',
    fieldType: 'list',
  },
  {
    fieldTitle: 'Payer Id',
    fieldKey: 'PayerID',
    fieldType: 'number',
  },
  {
    fieldTitle: 'Payer Name',
    fieldKey: 'PayerName',
    fieldType: 'text',
  },
  {
    fieldTitle: 'Payer Coordinator Id',
    fieldKey: 'PayerCoordinatorID',
    fieldType: 'number',
  },
  {
    fieldTitle: 'Payer Coordinator Name',
    fieldKey: 'PayerCoordinatorName',
    fieldType: 'text',
  },
  {
    fieldTitle: 'Patient Status Id',
    fieldKey: 'PatientStatusID',
    fieldType: 'number',
  },
  {
    fieldTitle: 'Patient Status Name',
    fieldKey: 'PatientStatusName',
    fieldType: 'text',
  },
  {
    fieldTitle: 'Wage Parity',
    fieldKey: 'WageParity',
    fieldType: 'text',
  },
  {
    fieldTitle: 'Wage Parity From Date 1',
    fieldKey: 'WageParityFromDate1',
    fieldType: 'date',
  },
  {
    fieldTitle: 'Wage Parity To Date 1',
    fieldKey: 'WageParityToDate1',
    fieldType: 'date',
  },
  {
    fieldTitle: 'Wage Parity From Date 2',
    fieldKey: 'WageParityFromDate2',
    fieldType: 'date',
  },
  {
    fieldTitle: 'Wage Parity To Date 2',
    fieldKey: 'WageParityToDate2',
    fieldType: 'date',
  },
  {
    fieldTitle: 'Primary Language Id',
    fieldKey: 'PrimaryLanguageID',
    fieldType: 'number',
  },
  {
    fieldTitle: 'Primary Language',
    fieldKey: 'PrimaryLanguage',
    fieldType: 'text',
  },
  {
    fieldTitle: 'Secondary Language Id',
    fieldKey: 'SecondaryLanguageID',
    fieldType: 'number',
  },
  {
    fieldTitle: 'Secondary Language',
    fieldKey: 'SecondaryLanguage',
    fieldType: 'text',
  },
  {
    fieldTitle: 'Allowed Caregiver Access to Mobile App',
    fieldKey: 'AllowedCaregiverAccessPatientInfoToMobileApp.CaregiverID',
    fieldType: 'list',
  },
  {
    fieldTitle: 'Last Modified Date',
    fieldKey: 'LastModifiedDate',
    fieldType: 'date',
  },
];

export const HHA_CUSTOM_CAREGIVER_FIELDS: Partial<CustomFieldModel>[] = [
  {
    fieldTitle: 'Id',
    fieldKey: 'ID',
    fieldType: 'number',
  },

  {
    fieldTitle: 'Middle Name',
    fieldKey: 'MiddleName',
    fieldType: 'text',
  },
  {
    fieldTitle: 'Initials',
    fieldKey: 'Intials',
    fieldType: 'text',
  },
  {
    fieldTitle: 'Gender',
    fieldKey: 'Gender',
    fieldType: 'text',
  },
  {
    fieldTitle: 'Caregiver Gender Id',
    fieldKey: 'CaregiverGenderID',
    fieldType: 'text',
  },
  {
    fieldTitle: 'Birth Date',
    fieldKey: 'BirthDate',
    fieldType: 'date',
  },
  {
    fieldTitle: 'Caregiver Code',
    fieldKey: 'CaregiverCode',
    fieldType: 'number',
  },
  {
    fieldTitle: 'Time and Attendance PIN',
    fieldKey: 'TimeAndAttendancePIN',
    fieldType: 'number',
  },
  {
    fieldTitle: 'Alternate Caregiver Code',
    fieldKey: 'AlternateCaregiverCode',
    fieldType: 'text',
  },
  {
    fieldTitle: 'Mobile Id',
    fieldKey: 'MobileID',
    fieldType: 'number',
  },
  {
    fieldTitle: 'Mobile Id Type Description',
    fieldKey: 'MobileIDTypeDescription',
    fieldType: 'text',
  },
  {
    fieldTitle: 'SSN',
    fieldKey: 'SSN',
    fieldType: 'text',
  },
  {
    fieldTitle: 'Ethnicity Id',
    fieldKey: 'Ethnicity.ID',
    fieldType: 'number',
  },
  {
    fieldTitle: 'Ethnicity Name',
    fieldKey: 'Ethnicity.Name',
    fieldType: 'text',
  },
  {
    fieldTitle: 'Rehire Date',
    fieldKey: 'RehireDate',
    fieldType: 'date',
  },
  {
    fieldTitle: 'Country of Birth',
    fieldKey: 'CountryOfBirth',
    fieldType: 'text',
  },
  {
    fieldTitle: 'Employee Type',
    fieldKey: 'EmployeeType',
    fieldType: 'text',
  },
  {
    fieldTitle: 'Marital Status Id',
    fieldKey: 'MaritalStatus.ID',
    fieldType: 'number',
  },
  {
    fieldTitle: 'Marital Status Name',
    fieldKey: 'MaritalStatus.Name',
    fieldType: 'text',
  },
  {
    fieldTitle: 'Dependents',
    fieldKey: 'Dependents',
    fieldType: 'text',
  },
  {
    fieldTitle: 'Status Id',
    fieldKey: 'Status.ID',
    fieldType: 'number',
  },
  {
    fieldTitle: 'Status Name',
    fieldKey: 'Status.Name',
    fieldType: 'text',
  },
  {
    fieldTitle: 'Employment Types',
    fieldKey: 'EmploymentTypes.Discipline',
    fieldType: 'list',
  },
  {
    fieldTitle: 'Employee Id',
    fieldKey: 'EmployeeID',
    fieldType: 'text',
  },
  {
    fieldTitle: 'Application Date',
    fieldKey: 'ApplicationDate',
    fieldType: 'date',
  },
  {
    fieldTitle: 'Team Id',
    fieldKey: 'Team.ID',
    fieldType: 'number',
  },
  {
    fieldTitle: 'Team Name',
    fieldKey: 'Team.Name',
    fieldType: 'text',
  },
  {
    fieldTitle: 'Location Id',
    fieldKey: 'Location.ID',
    fieldType: 'number',
  },
  {
    fieldTitle: 'Location Name',
    fieldKey: 'Location.Name',
    fieldType: 'text',
  },
  {
    fieldTitle: 'Branch Id',
    fieldKey: 'Branch.ID',
    fieldType: 'number',
  },
  {
    fieldTitle: 'Branch Name',
    fieldKey: 'Branch.Name',
    fieldType: 'text',
  },
  {
    fieldTitle: 'Hire Date',
    fieldKey: 'HireDate',
    fieldType: 'date',
  },
  {
    fieldTitle: 'First Work Date',
    fieldKey: 'FirstWorkDate',
    fieldType: 'date',
  },
  {
    fieldTitle: 'Last Work Date',
    fieldKey: 'LastWorkDate',
    fieldType: 'date',
  },
  {
    fieldTitle: 'Registry Number',
    fieldKey: 'RegistryNumber',
    fieldType: 'text',
  },
  {
    fieldTitle: 'Registry Checked Date',
    fieldKey: 'RegistryCheckedDate',
    fieldType: 'date',
  },
  {
    fieldTitle: 'Referral Source Id',
    fieldKey: 'ReferralSource.ID',
    fieldType: 'number',
  },
  {
    fieldTitle: 'Referral Source Name',
    fieldKey: 'ReferralSource.Name',
    fieldType: 'text',
  },
  {
    fieldTitle: 'Referral Person',
    fieldKey: 'ReferralPerson',
    fieldType: 'text',
  },
  {
    fieldTitle: 'Address Street 1',
    fieldKey: 'Address.Street1',
    fieldType: 'text',
  },
  {
    fieldTitle: 'Address Street 2',
    fieldKey: 'Address.Street2',
    fieldType: 'text',
  },
  {
    fieldTitle: 'Address City',
    fieldKey: 'Address.City',
    fieldType: 'text',
  },
  {
    fieldTitle: 'Address State',
    fieldKey: 'Address.State',
    fieldType: 'text',
  },
  {
    fieldTitle: 'Address Zip5',
    fieldKey: 'Address.Zip5',
    fieldType: 'number',
  },
  {
    fieldTitle: 'Address Zip4',
    fieldKey: 'Address.Zip4',
    fieldType: 'number',
  },
  {
    fieldTitle: 'Address Home Phone',
    fieldKey: 'Address.HomePhone',
    fieldType: 'text',
    fieldFormat: 'phoneNumber',
  },
  // {
  //   fieldTitle: 'Address Phone2',
  //   fieldKey: 'Address.Phone2',
  //   fieldType: 'text',
  // },
  // {
  //   fieldTitle: 'Address Phone3',
  //   fieldKey: 'Address.Phone3',
  //   fieldType: 'text',
  // },
  {
    fieldTitle: 'Emergency Contacts Names',
    fieldKey: 'EmergencyContacts.EmergencyContact.Name',
    fieldType: 'list',
  },
  {
    fieldTitle: 'Emergency Contacts Relationships Ids',
    fieldKey: 'EmergencyContacts.EmergencyContact.Relationship.ID',
    fieldType: 'list',
  },
  {
    fieldTitle: 'Emergency Contacts Relationships Names',
    fieldKey: 'EmergencyContacts.EmergencyContact.Relationship.Name',
    fieldType: 'list',
  },
  {
    fieldTitle: 'Emergency Contacts Addresses',
    fieldKey: 'EmergencyContacts.EmergencyContact.Address',
    fieldType: 'list',
  },
  {
    fieldTitle: 'Emergency Contacts Phone1',
    fieldKey: 'EmergencyContacts.EmergencyContact.Phone1',
    fieldType: 'list',
    fieldFormat: 'phoneNumber',
  },
  {
    fieldTitle: 'Emergency Contacts Phone2',
    fieldKey: 'EmergencyContacts.EmergencyContact.Phone2',
    fieldType: 'list',
    fieldFormat: 'phoneNumber',
  },
  {
    fieldTitle: 'Notification Preference Method Id',
    fieldKey: 'NotificationPreferences.Method.ID',
    fieldType: 'number',
  },
  {
    fieldTitle: 'Notification Preference Method Name',
    fieldKey: 'NotificationPreferences.Method.Name',
    fieldType: 'text',
  },
  {
    fieldTitle: 'Notification Preference Email',
    fieldKey: 'NotificationPreferences.Email',
    fieldType: 'text',
  },
  {
    fieldTitle: 'Notification Preference Mobile or SMS',
    fieldKey: 'NotificationPreferences.MobileOrSMS',
    fieldType: 'text',
  },
  {
    fieldTitle: 'Notification Preference Voice Message',
    fieldKey: 'NotificationPreferences.VoiceMessage',
    fieldType: 'text',
  },
  {
    fieldTitle: 'Caregiver Office Ids',
    fieldKey: 'CaregiverOffices.Office.OfficeID',
    fieldType: 'list',
  },
  {
    fieldTitle: 'Caregiver Office Names',
    fieldKey: 'CaregiverOffices.Office.OfficeName',
    fieldType: 'list',
  },
  {
    fieldTitle: 'Caregiver Office Is Primary',
    fieldKey: 'CaregiverOffices.Office.IsPrimary',
    fieldType: 'list',
  },
  {
    fieldTitle: 'Inactive Reason Id',
    fieldKey: 'InactiveReasonID',
    fieldType: 'number',
  },
  {
    fieldTitle: 'Inactive Reason',
    fieldKey: 'InactiveReason',
    fieldType: 'text',
  },
  {
    fieldTitle: 'Inactive Note',
    fieldKey: 'InactiveNote',
    fieldType: 'text',
  },
  {
    fieldTitle: 'Terminated Date',
    fieldKey: 'TerminatedDate',
    fieldType: 'date',
  },
  {
    fieldTitle: 'Professional License Number',
    fieldKey: 'ProfessionalLicensenumber',
    fieldType: 'text',
  },
  {
    fieldTitle: 'NPI Number',
    fieldKey: 'NPINumber',
    fieldType: 'text',
  },
  {
    fieldTitle: 'Signed Payroll Agreement Date',
    fieldKey: 'SignedPayrollAgreementDate',
    fieldType: 'date',
  },
  {
    fieldTitle: 'Language 1 Id',
    fieldKey: 'LanguageID1',
    fieldType: 'number',
  },
  {
    fieldTitle: 'Language 1',
    fieldKey: 'Language1',
    fieldType: 'text',
  },
  {
    fieldTitle: 'Language 2 Id',
    fieldKey: 'LanguageID2',
    fieldType: 'number',
  },
  {
    fieldTitle: 'Language 2',
    fieldKey: 'Language2',
    fieldType: 'text',
  },
  {
    fieldTitle: 'Language 3 Id',
    fieldKey: 'LanguageID3',
    fieldType: 'number',
  },
  {
    fieldTitle: 'Language 3',
    fieldKey: 'Language3',
    fieldType: 'text',
  },
  {
    fieldTitle: 'Language 4 Id',
    fieldKey: 'LanguageID4',
    fieldType: 'number',
  },
  {
    fieldTitle: 'Language 4',
    fieldKey: 'Language4',
    fieldType: 'text',
  },
  {
    fieldTitle: 'Last Modified Date',
    fieldKey: 'LastModifiedDate',
    fieldType: 'date',
  },
  {
    fieldTitle: 'Time Zone',
    fieldKey: 'TimeZone',
    fieldType: 'text',
  },
];
